'use strict'

var metadata = require('libphonenumber-js/metadata.min.json')
var createInput = require('../commonjs/InputBasic').createInput

var Input = createInput(metadata)

exports = module.exports = Input
exports['default']       = Input


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/basic-input/index.commonjs.js
// module id = 1643
// module chunks = 0 1